<template>
  <w-sliding-popup type="setting"  ref="slidingPopup" class="add-log-head" title="베이스라인 정책 설정" width="500px" @close="close">
    <div slot="content">
      <div class="title-h4">베이스라인 정보</div>
      <el-form :model="baseLineRule" label-position="top" ref="baseLineRuleForm">
        <el-row>
          <el-form-item label="필터명">
            <em>{{baseLineRule.filterName}}</em>
          </el-form-item>
        </el-row>
        <el-row class="mr-b25">
          <el-col :span="12">
            <el-form-item label="통계 기간" prop="term">
              <el-select v-model="baseLineRule.statsPeriod">
                <el-option
                  v-for="item in termSelectData"
                  :key="item.statsPeriod"
                  :label="item.label"
                  :value="item.statsPeriod">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="상한" prop="max">
                    <el-input type="Number" v-model="baseLineRule.upperBound" @blur="createChartData" suffix-icon="fas fa-percent"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="하한" prop="min">
                  <el-input type="Number" v-model="baseLineRule.lowerBound" @blur="createChartData" suffix-icon="fas fa-percent"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <div class="title-h4">예상 베이스라인</div>
      <el-row>
        <w-base-line-example-chart ref="baseLineExampleChart" :baselineData="baselineData" :baseLineRule="baseLineRule"></w-base-line-example-chart>
      </el-row>
    </div>
    <div slot="footer">
      <el-button size="large" type="solid" @click="updateBaseline">저장</el-button>
      <el-button @click="close" size="large" >취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import BaselineAPI from '@/api/settings/log/lms-baseline-setting';
import msgUtil from '@/utils/message';

import WBaseLineExampleChart from '../components/BaseLineExampleChart';

export default {
  name: 'WBaseLineRuleSettingPopup',
  props: {
    selectFilter: {
      type: Object,
    },
  },
  components: {
    WBaseLineExampleChart,
  },
  data() {
    return {
      baseLineRule: {},
      baselineData: [],
      termSelectData: [
        { statsPeriod: 12, label: '12개월' },
        { statsPeriod: 6, label: '6개월' },
        { statsPeriod: 3, label: '3개월' },
        { statsPeriod: 1, label: '1개월' },
      ],
    };
  },
  methods: {
    createChartData() {
      this.$refs.baseLineExampleChart.createChartData();
    },
    /**
     * 베이스 라인 설정 수정
     * @author leesy918
     * @return {[type]} [description]
     */
    updateBaseline() {
      const params = this.baseLineRule;

      BaselineAPI.updateLmsBaseline(params).then((response) => {
        if (response.data.success) {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '베이스라인', true));
          this.$emit('loadData');
          this.close();
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '베이스라인', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '베이스라인', false));
        throw new Error(e);
      });
    },
    /**
     * 베이스라인 데이터 조회
     * @author leesy918
     * @return {[type]} [description]
     */
    loadData() {
      this.baseLineRule = cloneDeep(this.selectFilter);
      const params = this.baseLineRule;
      BaselineAPI.getFilterBaseline(params).then((response) => {
        if (response.data.success) {
          this.baselineData = response.data.data;
          this.$refs.slidingPopup.visible = true;
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '베이스라인', false));
        throw new Error(e);
      });
    },
    open() {
      this.$nextTick(() => {
        this.loadData();
      });
    },
    close() {
      this.baseLineRule = {};
      this.$refs.slidingPopup.visible = false;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Alarm/popup/BaseLineRuleSettingPopup.vue